import React from 'react';
import { LuCircleAlert } from 'react-icons/lu';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import { GetEmailDtoStatusEnum } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../translations';

interface EmailAddressWithStatusProps {
  email?: string;
  status?: GetEmailDtoStatusEnum;
}

export const EmailAddressWithStatus: React.FC<EmailAddressWithStatusProps> = ({
  email,
  status,
}) => {
  const showWarning = status && status !== GetEmailDtoStatusEnum.Sent;
  const { t, tk } = useTranslation('administrationLng');

  return (
    <div className="d-flex align-items-center gap-2">
      <span>{email || ''}</span>
      {showWarning && (
        <OverlayTrigger overlay={<Tooltip>{t(tk.survey.sendError)}</Tooltip>}>
          <LuCircleAlert className="ms-2 text-red" size={16} />
        </OverlayTrigger>
      )}
    </div>
  );
};
